var _ellipse, _rect, _rect2, _path, _path2, _path3, _ellipse2, _ellipse3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLevel0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 257,
    viewBox: "0 0 204 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.1855,
    cy: 121.582,
    rx: 84.8522,
    ry: 80.8748,
    fill: "#24C2F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93.8374,
    y: 39.9424,
    width: 51.4748,
    height: 37.1229,
    rx: 2,
    transform: "rotate(-30.018 93.8374 39.9424)",
    fill: "#24C2F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91.5054,
    y: 0.932617,
    width: 51.4748,
    height: 37.1229,
    rx: 2,
    transform: "rotate(52.5921 91.5054 0.932617)",
    fill: "#24C2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2634 157.573C52.2467 157.141 51.0829 157.62 50.664 158.642L31.9333 204.339L16.9326 198.547C13.4044 197.185 9.47352 198.953 8.15278 202.497L0.213158 223.802C-0.172566 224.837 0.350069 225.999 1.3805 226.397L21.3643 234.112C21.4931 234.21 21.6354 234.293 21.7902 234.358L60.0182 250.592C61.0349 251.024 62.1987 250.545 62.6176 249.523L92.5738 176.439C92.9927 175.417 92.5081 174.239 91.4914 173.807L53.2634 157.573Z",
    fill: "#24C2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.247 184.139C103.606 185.039 103.822 186.278 104.73 186.908L145.315 215.047L136.426 228.447C134.336 231.598 135.216 235.818 138.392 237.872L157.484 250.217C158.412 250.816 159.659 250.557 160.269 249.636L172.11 231.787C172.233 231.682 172.345 231.561 172.443 231.423L196.535 197.593C197.176 196.693 196.96 195.453 196.052 194.824L131.143 149.819C130.235 149.19 128.98 149.409 128.339 150.309L104.247 184.139Z",
    fill: "#24C2F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9272 214.389L88.5338 183.896",
    stroke: "#F5F5F5",
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.7821,
    cy: 96.3916,
    rx: 3.97745,
    ry: 5.30326,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.995,
    cy: 99.043,
    rx: 3.97745,
    ry: 5.30326,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9492 132.453C59.7675 133.305 60.3106 134.149 61.1734 134.271C63.9088 134.657 66.6965 134.537 69.3967 133.913C72.6103 133.17 75.6216 131.731 78.2183 129.698C80.815 127.664 82.9337 125.085 84.4249 122.143C85.6779 119.671 86.4622 116.994 86.7432 114.245C86.8318 113.379 86.1426 112.649 85.2717 112.621C84.4007 112.593 83.6789 113.278 83.5804 114.144C83.3202 116.431 82.6545 118.657 81.6103 120.717C80.3279 123.247 78.5058 125.464 76.2727 127.213C74.0396 128.962 71.4498 130.2 68.6862 130.839C66.4359 131.359 64.1151 131.472 61.833 131.176C60.9688 131.064 60.1309 131.601 59.9492 132.453Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLevel0);
export default __webpack_public_path__ + "static/media/UserLevel0.f35012bf8e8ccedd03c22a206d2d55ab.svg";
export { ForwardRef as ReactComponent };